module.exports = __webpack_public_path__ + "static/media/logo.fe1a35db.svg";